import Model from 'ampersand-model';
import ExhibitElementCollection from '../collections/ExhibitElementCollection';
import * as Data from '../data/index';
import result from 'lodash/result';
import xhr from 'xhr';

const MIN_ERROR_STATUS = 400;
const HTTP_ERROR_PREFIX = 'HTTP';

export default Model.extend({
	idAttribute: 'id',
	props: {
		id: 'string',
		aboutHref: 'string'
	},
	collections: {
		elements: ExhibitElementCollection
	},
	sync(method, model, options) {
		const self = this;

		if (method === 'read') {
			const hasUrl = options.url !== undefined || result(model, 'urlRoot') !== undefined;

			if (hasUrl) {
				Model.prototype.sync.call(this, method, model, options);
			} else {
				//Use static data since we are not connected to the backend
				const fixtureUrl = Data[this.id];

				xhr({
					url: fixtureUrl,
					json: true
				},
				(err, resp, body) => {
					if (err || resp.statusCode >= MIN_ERROR_STATUS) {
						if (options.error) {
							options.error(resp, 'error', HTTP_ERROR_PREFIX + resp.statusCode);
						}
					} else {
						this.set(body);

						if (options.success) {
							options.success(resp.body, 'success', resp);
						}
					}
				});
			}
		} else {
			Model.prototype.sync.call(this, method, model, options);
		}
	}
});


// WEBPACK FOOTER //
// ./src/models/ExhibitModel.js